import { MqlCompiledQuery } from '@deqo/mql-js';
import { injectable } from 'inversify';
import { throttle } from 'throttle-debounce';
import { ObjectManager } from '../../../../concepts/objects';
import { ActiveObject, resolve } from '../../../Container';
import { Physical } from '../../../canvas/entities/Physical';
import { EffectDirector, Effects } from '../../../canvas/visualization/EffectDirector';
import { Lens } from '../Lens';
import { MqlUtils } from '../MqlUtils';

@injectable()
export class FadeLens extends ActiveObject implements Lens {

    @resolve(EffectDirector) private effects: EffectDirector;
    @resolve(ObjectManager) private objects: ObjectManager;
    @resolve(MqlUtils) private mqlUtils: MqlUtils;

    private filter = null as MqlCompiledQuery;
    private activeSet = new Set<Physical>();

    constructor() {
        super();
    }

    public configure(filter: MqlCompiledQuery): void {
        this.filter = filter;
    }

    public start() {
        const applyThrottled = throttle(0, this.apply.bind(this), true);
        this.burden(
            this.objects.on('updated', applyThrottled),
            () => this.cleanUp(),
        );
        this.apply();
    }

    private apply() {

        const scope = this.mqlUtils.createScope();
        const elmts = Array.from(this.objects.getAll(Physical));
        const hits = new Set(elmts.filter(x => this.filter.test(scope, x)));

        // Remove effect from any that are no longer hits
        for (const x of this.activeSet) {
            if (!x.alive || hits.has(x)) continue;
            this.effects.untrigger('fade', x);
            this.activeSet.delete(x);
        }

        // Add effect to any that are now hits
        for (const x of hits) {
            if (!x.alive || this.activeSet.has(x)) continue;
            this.effects.trigger(Effects.create('fade', -1, { value: .1 }), x);
            this.activeSet.add(x);
        }
    }

    private cleanUp() {
        for (const x of this.activeSet) {
            if (!x.alive) continue;
            this.effects.untrigger('fade', x);
            this.activeSet.delete(x);
        }
    }
}
